export default __webpack_public_path__ + "static/media/grateful-banner.397df085.webp";